import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/styles/globals.css");
